import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/cone-volume-calculator',
  component: () => import('../../routes/ConeVolumeCalculator.svelte'),
  card: {
    id: 'cone-volume-calculator',
    title: 'Cone Volume Calculator',
    description: 'Calculate the volume, surface area, curved surface area, and slant height of a right circular cone from radius and height.',
    icon: 'change_history',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/cone-volume-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Cone Volume Calculator – Find Volume & Surface Area of a Cone',
    description:
      'Free cone volume calculator to find volume, total surface area, curved surface area, base area, and slant height of a right circular cone. Includes formula and step-by-step results.',
  },
};

export default meta;